import {
  useCallback, useMemo, useRef, useState,
} from 'react';
import Slider from 'react-slick';

const useSlickCarousel = () => {
  const sliderRef = useRef<Slider>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const postSliderChange = useCallback((currentSlide: number) => setActiveIndex(currentSlide), []);

  const pauseSlider = useCallback(() => {
    sliderRef.current?.slickPause();
  }, []);

  const playSlider = useCallback(() => {
    sliderRef.current?.slickPlay();
  }, []);

  return useMemo(() => ({
    activeIndex,
    sliderRef,
    postSliderChange,
    pauseSlider,
    playSlider,
  }), [
    activeIndex,
    sliderRef,
    postSliderChange,
    pauseSlider,
    playSlider,
  ]);
};

export default useSlickCarousel;
